import { BaseComponent } from '../../base-component';

export class BreadcrumbComponent extends BaseComponent {
    public readonly rootSelector: string = '.js_pdp_breadcrumb';

    public async onHtmlLoaded(): Promise<unknown> {
        return o_global.eventQBus.emit('ftnav.breadcrumb.register');
    }
}
